import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import styles from './tabs.module.css'

export interface TabsProps {
  tabNames: string[]
  onChangeTab: (tabName: string) => void
  activeTab?: string
}

const Tabs = ({ tabNames, onChangeTab, activeTab }: TabsProps) => {
  const [selectedTab, setSelectedTab] = useState(
    activeTab ?? (tabNames.length ? tabNames[0] : '')
  )

  useEffect(() => {
    if (tabNames.length === 0) return
    setSelectedTab(activeTab ?? tabNames[0])
  }, [tabNames]) //eslint-disable-line

  return (
    <div className="mb-4">
      <Row noGutters>
        {tabNames.map((tab, i) => {
          return (
            <Col
              className={
                `col-auto ${styles.tab} ` +
                (tab === selectedTab ? styles.tabActive : '')
              }
              key={tab}
              onClick={() => {
                setSelectedTab(tab)
                onChangeTab(tab)
              }}
              data-testid={`tab-${i}`}
            >
              <h4>{tab}</h4>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export default Tabs
